import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationComponent } from 'app/shared/notification/notification.component';
import { SpinnerService } from 'app/services/spinner.service';
import { MedicoService } from 'app/services/medico.service';

@Component({
  selector: 'app-activar-cuenta-medico',
  templateUrl: './activar-cuenta-medico.component.html',
  styleUrls: ['./activar-cuenta-medico.component.scss']
})
export class ActivarCuentaMedicoComponent implements OnInit {

  activationForm: FormGroup;
  token: string;
  medicoData: any;
  tokenValido: boolean = false;

  constructor(
    private medicoService: MedicoService,
    private actRoute: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private spinService: SpinnerService
  ) {
    this.iniciarFormulario();
    this.token = this.actRoute.snapshot.paramMap.get("token");
    this.verificarToken();
  }

  ngOnInit(): void { }

  iniciarFormulario() {
    this.activationForm = new FormGroup({
      email: new FormControl({ value: '', disabled: true }),
      password: new FormControl('', [Validators.required, Validators.minLength(6)]),
      password_confirmation: new FormControl('', Validators.required)
    }, { validators: passwordMatcher });
  }

  verificarToken() {
    this.spinService.mostrarSpinner();
    this.medicoService.verificarTokenActivacion(this.token).subscribe(
      (response: any) => {
        if (response.valido) {
          this.tokenValido = true;
          this.medicoData = response.medico;
          this.activationForm.patchValue({
            email: this.medicoData.email
          });
          this.spinService.ocultarSpinner();
        } else {
          this.spinService.ocultarSpinner();
          this.openSnackBar(response.mensaje || "Token no válido", "error");
          setTimeout(() => {
            this.router.navigate(['/auth/login-medico']);
          }, 2500);
        }
      },
      error => {
        this.spinService.ocultarSpinner();

        console.error('=== ERROR COMPLETO TOKEN ACTIVACIÓN MÉDICO ===');
        console.error('Status:', error.status);
        console.error('Error completo:', error);
        console.error('Error.error:', error.error);
        console.error('===============================================');

        const mensaje = error.error?.mensaje || "El enlace de activación no es válido o ha expirado";

        if (error.error?.debug) {
          console.error('=== DEBUG TOKEN ACTIVACIÓN MÉDICO ===');
          console.error('Token usado:', error.error.debug.usado);
          console.error('Fecha expiración:', error.error.debug.fecha_expiracion);
          console.error('Fecha actual:', error.error.debug.fecha_actual);
          console.error('Es futuro:', error.error.debug.es_futuro);
          console.error('Mensaje completo:', mensaje);
          console.error('=====================================');
        }

        this.openSnackBar(mensaje, "error");
        setTimeout(() => {
          this.router.navigate(['/auth/login-medico']);
        }, 2500);
      }
    );
  }

  activarCuenta() {
    if (this.activationForm.valid) {
      this.spinService.mostrarSpinner();
      const datos = {
        token: this.token,
        password: this.activationForm.get('password').value,
        password_confirmation: this.activationForm.get('password_confirmation').value
      };

      this.medicoService.activarCuentaYCrearPassword(datos).subscribe(
        (response: any) => {
          this.spinService.ocultarSpinner();
          this.openSnackBar("¡Cuenta activada exitosamente! Ya puedes iniciar sesión", "exito");
          setTimeout(() => {
            this.router.navigate(['/auth/login-medico']);
          }, 2500);
        },
        error => {
          this.spinService.ocultarSpinner();
          const mensaje = error.error?.error || "Error al activar la cuenta";
          this.openSnackBar(mensaje, "error");
        }
      );
    } else {
      this.openSnackBar("Por favor, completa todos los campos correctamente", "error");
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.openFromComponent(NotificationComponent, {
      data: {
        message: message,
        action: action
      },
      duration: 2500,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: [action]
    });
  }

  get password() { return this.activationForm.get('password'); }
  get password_confirmation() { return this.activationForm.get('password_confirmation'); }
}

function passwordMatcher(control: AbstractControl): { [key: string]: boolean } | null {
  const password = control.get('password');
  const passwordConfirmation = control.get('password_confirmation');
  if (!password || !passwordConfirmation) {
    return null;
  }
  return password.value !== passwordConfirmation.value ? { 'passwordError': true } : null;
}
